import React from 'react';
import axios from 'axios';
import { Link, withRouter } from 'react-router-dom';
import { trackPromise } from 'react-promise-tracker';
import { notify } from '../helpers';
const util = require('util');

class Unsubscribe extends React.Component
{
    constructor(props) {
        super(props);

        this.voteCode = props.match.params.voteCode;
        console.log(`Unsubscribe.ctor, voteCode: ${this.voteCode}`);
    }

    componentDidMount() {
        trackPromise(axios.get('/unsubscribe2/' + this.voteCode)
            .then(response => {
            })
            .catch(error => {
                console.error(error);
                notify(error);
            })
        );
    }

    render() {
        return (
            <div>
            </div>
        );
    }
}

export default withRouter(Unsubscribe);